<template>
  <div></div>
</template>

<script>
import { createCookie } from '../../helpers'
import { mapActions } from 'vuex'

export default {
  name: 'LogoutPage',
  methods: {
    ...mapActions(['doRemoveMe'])
  },
  created () {
    createCookie('redecienciaToken', '', -1)
    this.doRemoveMe()
    this.$router.push('/login')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/LogoutPage.vue